import { Button, DatePicker } from '../../Elements'
import { useState } from 'react'
import RaytebModal from './RaytebModal'
import { toast } from 'react-toastify'
import { useSelector } from 'react-redux'
import { ReducerType } from '../../../storeManager/ReducerType'
import useFetch from '../../../_services/fetch'
import { RaytebRequests } from '../../../_services'
import { LoginInterface } from '../../../Interfaces/LoginInterface'

type Dates = {
  fromDate: string
  toDate: string
}

const ZipPatientRecordModal = () => {
  const [date, setDate] = useState<Dates>({
    fromDate: new Date().toISOString(),
    toDate: new Date().toISOString(),
  })
  const [show, setShow] = useState<boolean>(false)
  const user = useSelector<ReducerType, LoginInterface>(
    (state) => state.reducerUser
  )
  const center = useSelector<ReducerType, CenterViewModel>(
    (state) => state.reducerCenter
  )
  const handleFromDateChange = (e) => {
    const fromDateInput = document.getElementById('fromDate')
    const raytebValue = fromDateInput?.getAttribute('rayteb-value')
    setDate({ ...date, fromDate: raytebValue! })
  }
  const { reFetch } = useFetch<number, unknown, { from: Date; to: Date }>({
    request: RaytebRequests.Patient_ZipPatientProfiles_GET({
      token: user.token,
      centerId: center.id,
    }),
    onSuccess(data) {
      const _from = new Date(date.fromDate)
      const _to = new Date(date.toDate)
      const daysDifference = dateDifferenceInDays(_from, _to)
      if (daysDifference <= 30) {
        // window.open(
        //   `${
        //     process.env.REACT_APP_Rayteb_Domain
        //   }/${center.subdomain}/fa-ir/EHRPatientRecordPrint/GetZipPatientRecord?from=${_from.toISOString()}&to=${_to.toISOString()}`

        //   );
        handleDownload(data)
      } else if (daysDifference <= 180) {
        toast.info('خروجی شما 24 ساعت آینده در قسمت دانلود ها قابل مشاهده است')
      }
      setShow(false)
    },
  })
  const handleToDateChange = (e) => {
    const toDateInput = document.getElementById('toDate')
    const raytebValue = toDateInput?.getAttribute('rayteb-value')
    setDate({ ...date, toDate: raytebValue! })
  }
  const validateDate = (fromDate, toDate) => {
    return new Date(toDate) >= new Date(fromDate)
  }
  const dateDifferenceInDays = (date1, date2) => {
    const oneDay = 24 * 60 * 60 * 1000 // milliseconds in a day
    const differenceInTime = Math.abs(date2.getTime() - date1.getTime())
    return differenceInTime / oneDay
  }
  const handleDownload = async (id) => {
    try {
      // Replace 'your-download-url' with the actual URL of the ZIP file
      //  const response = await fetch(
      //    `${process.env.REACT_APP_Rayteb_Domain}/${
      //      center.subdomain
      //    }/fa-ir/EHRPatientRecordPrint/GetZipPatientRecord?from=${_from.toISOString()}&to=${_to.toISOString()}`
      //  );

      //  if (!response.ok) {
      //    throw new Error(`HTTP error! status: ${response.status}`);
      //  }

      //  const blob = await response.blob();
      //  const url = window.URL.createObjectURL(blob);
      const url = `${window.env['APP_Rayteb_Domain']}/${center.subdomain}/fa-ir/EHRPatientRecordPrint/GetZipPatientRecord?id=${id}`
      const a = document.createElement('a')
      a.style.display = 'none'
      a.href = url
      a.target = '_blank'
      a.download = 'your-file-name.zip' // Replace with the desired file name

      document.body.appendChild(a)
      a.click()

      window.URL.revokeObjectURL(url)
      document.body.removeChild(a)
    } catch (error) {
      debugger
      console.error('Download failed:', error)
    }
  }

  function onBackup() {
    const _from = new Date(date.fromDate)
    const _to = new Date(date.toDate)
    if (validateDate(date.fromDate, date.toDate)) {
      if (dateDifferenceInDays(_from, _to) > 180) {
        toast.error('تاریخ کم تر از 6 ماه را انتخاب کنید')
      } else {
        reFetch(null, {
          to: _to,
          from: _from,
        })
      }
    } else {
      toast.error('تاریخ وارد شده  صحیح نمی باشد')
    }
  }
  return (
    <>
      <button
        className=' mt-5 mr-auto flex ml-4 bg-transparent hover:bg-primaryLight hover:text-white text-primaryLight font-semibold text-xs py-2 px-2 border border-primaryLight rounded'
        onClick={() => {
          setShow(true)
        }}
      >
        بارگیری اطلاعات
      </button>
      <RaytebModal
        isOpen={show}
        className={'w-full md:w-[40%]'}
        title='بارگیری اطلاعات'
        hideModal={() => {
          setShow(false)
        }}
      >
        <div className='flex justify-center items-center px-3'>
          <div className='flex justify-center items-center gap-x-2 px-2 w-full '>
            <div className='w-full'>
              <DatePicker
                innerText='از تاریخ'
                isRequired={true}
                className='h-7 w-full'
                id='fromDate'
                name='fromDate'
                raytebValue={date.fromDate}
                value={new Date(date.fromDate).toShamsi()}
                onChange={handleFromDateChange}
              />
            </div>
            <div className='w-full'>
              <DatePicker
                innerText='تا تاریخ'
                isRequired={true}
                className='h-7 w-full'
                id='toDate'
                name='toDate'
                raytebValue={date.toDate}
                value={new Date(date.toDate).toShamsi()}
                onChange={handleToDateChange}
              />
            </div>
          </div>
        </div>
        <Button
          className='!bg-secondary text-white h-9 w-24 text-xs rounded-xl m-auto mt-5 mb-2'
          onClick={() => {
            onBackup()
          }}
        >
          خروجی
        </Button>
      </RaytebModal>
    </>
  )
}

export default ZipPatientRecordModal
